import React from 'react';
const TableContext = React.createContext({
    columns: [],
});
export const TableProvider = ({ children, value, }) => {
    return React.createElement(TableContext.Provider, { value: value }, children);
};
export const useTableContext = () => {
    return React.useContext(TableContext);
};
//# sourceMappingURL=TableProvider.js.map